/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './game.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/common';
import * as import3 from '../../../../app/+tournament/game/game.component';
import * as import4 from '@ngrx/store/src/store';
const styles_GameComponent:any[] = [import0.styles];
export const RenderType_GameComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_GameComponent,
  data: {}
}
);
function View_GameComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'i',[[
        'class',
        'material-icons'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n          ',
      '\n        '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (v.context.$implicit? 'favorite': 'favorite_border');
    ck(v,1,0,currVal_0);
  });
}
function View_GameComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),22,'div',([] as any[]),[[
        8,
        'className',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'victories'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'i',[[
        'class',
        'material-icons'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['whatshot'])),
    (l()(),import1.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'lives'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),1,(null as any),View_GameComponent_3)),
    import1.ɵdid(401408,(null as any),0,import2.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.matchFinished(v.context.$implicit,v.context.ngForOf[(1 - v.context.index)])) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Winner!'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = ((v.context.$implicit == null)? (null as any): v.context.$implicit.livesList);
    ck(v,14,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import1.ɵinlineInterpolate(1,'player player-n',v.context.index,'');
    ck(v,0,0,currVal_0);
    const currVal_1:any = ((v.context.$implicit == null)? (null as any): v.context.$implicit.name);
    ck(v,3,0,currVal_1);
    const currVal_2:any = ((v.context.$implicit == null)? (null as any): v.context.$implicit.victories);
    ck(v,9,0,currVal_2);
  });
}
function View_GameComponent_4(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'next-player'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n      ',
      '\n    '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = ((v.context.$implicit == null)? (null as any): v.context.$implicit.name);
    ck(v,1,0,currVal_0);
  });
}
function View_GameComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),21,'div',[[
        'class',
        'game'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'playing'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),2,(null as any),View_GameComponent_2)),
    import1.ɵdid(401408,(null as any),0,import2.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
    ,{
      ngForOf: [
        0,
        'ngForOf'
      ]
      ,
      ngForTrackBy: [
        1,
        'ngForTrackBy'
      ]

    }
    ,(null as any)),
    import1.ɵpid(65536,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'vs'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      .vs\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'queue'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['next'])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),2,(null as any),View_GameComponent_4)),
    import1.ɵdid(401408,(null as any),0,import2.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
    ,{
      ngForOf: [
        0,
        'ngForOf'
      ]
      ,
      ngForTrackBy: [
        1,
        'ngForTrackBy'
      ]

    }
    ,(null as any)),
    import1.ɵpid(65536,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import1.ɵunv(v,5,0,import1.ɵnov(v,6).transform(co.playing));
    const currVal_1:any = ((co.player == null)? (null as any): co.player.id);
    ck(v,5,0,currVal_0,currVal_1);
    const currVal_2:any = import1.ɵunv(v,18,0,import1.ɵnov(v,19).transform(co.queue));
    const currVal_3:any = ((co.player == null)? (null as any): co.player.id);
    ck(v,18,0,currVal_2,currVal_3);
  },(null as any));
}
function View_GameComponent_5(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'no-players'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  No players yet.\n']))
  ]
  ,(null as any),(null as any));
}
function View_GameComponent_8(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'number'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'i',[[
        'class',
        'material-icons'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['whatshot'])),
    (l()(),import1.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(null as any));
}
function View_GameComponent_9(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'number'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n      ',
      '\n    '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = ((<any>v.parent).context.index + 1);
    ck(v,1,0,currVal_0);
  });
}
function View_GameComponent_10(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'i',[[
        'class',
        'material-icons'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (v.context.$implicit? 'favorite': 'favorite_border');
    ck(v,1,0,currVal_0);
  });
}
function View_GameComponent_7(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),24,'div',[[
        'class',
        'player'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),2,(null as any),View_GameComponent_8)),
    import1.ɵdid(8192,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(65536,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),2,(null as any),View_GameComponent_9)),
    import1.ɵdid(8192,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(65536,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n      ',
      '\n    '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'victories'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'i',[[
        'class',
        'material-icons'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['whatshot'])),
    (l()(),import1.ɵted((null as any),[
      '\n      ',
      '\n    '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'lives'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),1,(null as any),View_GameComponent_10)),
    import1.ɵdid(401408,(null as any),0,import2.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (v.context.$implicit.victories === import1.ɵunv(v,3,0,import1.ɵnov(v,4).transform(co.maxVictories)));
    ck(v,3,0,currVal_0);
    const currVal_1:any = (v.context.$implicit.victories !== import1.ɵunv(v,7,0,import1.ɵnov(v,8).transform(co.maxVictories)));
    ck(v,7,0,currVal_1);
    const currVal_4:any = ((v.context.$implicit == null)? (null as any): v.context.$implicit.livesList);
    ck(v,22,0,currVal_4);
  },(ck,v) => {
    const currVal_2:any = ((v.context.$implicit == null)? (null as any): v.context.$implicit.name);
    ck(v,11,0,currVal_2);
    const currVal_3:any = ((v.context.$implicit == null)? (null as any): v.context.$implicit.victories);
    ck(v,17,0,currVal_3);
  });
}
function View_GameComponent_6(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'leaderboard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Leaderboard'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),2,(null as any),View_GameComponent_7)),
    import1.ɵdid(401408,(null as any),0,import2.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
    ,{
      ngForOf: [
        0,
        'ngForOf'
      ]
      ,
      ngForTrackBy: [
        1,
        'ngForTrackBy'
      ]

    }
    ,(null as any)),
    import1.ɵpid(65536,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import1.ɵunv(v,6,0,import1.ɵnov(v,7).transform(co.leaderboard));
    const currVal_1:any = ((co.player == null)? (null as any): co.player.id);
    ck(v,6,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_GameComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(2,[
    (l()(),import1.ɵand(8388608,(null as any),(null as any),2,(null as any),View_GameComponent_1)),
    import1.ɵdid(8192,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(65536,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),2,(null as any),View_GameComponent_5)),
    import1.ɵdid(8192,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(65536,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),2,(null as any),View_GameComponent_6)),
    import1.ɵdid(8192,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(65536,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import3.GameComponent = v.component;
    const currVal_0:any = import1.ɵunv(v,1,0,import1.ɵnov(v,2).transform(co.isPlaying));
    ck(v,1,0,currVal_0);
    var tmp_1_0:any = (null as any);
    const currVal_1:boolean = !(((tmp_1_0 = import1.ɵunv(v,5,0,import1.ɵnov(v,6).transform(co.leaderboard))) == null)? (null as any): tmp_1_0.length);
    ck(v,5,0,currVal_1);
    var tmp_2_0:any = (null as any);
    const currVal_2:any = (((tmp_2_0 = import1.ɵunv(v,9,0,import1.ɵnov(v,10).transform(co.leaderboard))) == null)? (null as any): tmp_2_0.length);
    ck(v,9,0,currVal_2);
  },(null as any));
}
function View_GameComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'ept-game',([] as any[]),(null as any),(null as any),(null as any),View_GameComponent_0,RenderType_GameComponent)),
    import1.ɵdid(57344,(null as any),0,import3.GameComponent,[import4.Store],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const GameComponentNgFactory:import1.ComponentFactory<import3.GameComponent> = import1.ɵccf('ept-game',import3.GameComponent,View_GameComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/+tournament/game/game.component.ngfactory.ts